var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99992 1.83331C4.25325 1.83331 2.83325 3.25331 2.83325 4.99998C2.83325 6.71331 4.17325 8.09998 5.91992 8.15998C5.97325 8.15331 6.02659 8.15331 6.06659 8.15998C6.07992 8.15998 6.08659 8.15998 6.09992 8.15998C6.10659 8.15998 6.10659 8.15998 6.11325 8.15998C7.81992 8.09998 9.15992 6.71331 9.16659 4.99998C9.16659 3.25331 7.74659 1.83331 5.99992 1.83331Z",
    fill: "#DCDBE7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38664 9.93336C7.52664 8.69336 4.49331 8.69336 2.61997 9.93336C1.77331 10.5 1.30664 11.2667 1.30664 12.0867C1.30664 12.9067 1.77331 13.6667 2.61331 14.2267C3.54664 14.8534 4.77331 15.1667 5.99997 15.1667C7.22664 15.1667 8.45331 14.8534 9.38664 14.2267C10.2266 13.66 10.6933 12.9 10.6933 12.0734C10.6866 11.2534 10.2266 10.4934 9.38664 9.93336Z",
    fill: "#DCDBE7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3267 5.39332C13.4334 6.68665 12.5134 7.81999 11.2401 7.97332C11.2334 7.97332 11.2334 7.97332 11.2267 7.97332H11.2067C11.1667 7.97332 11.1267 7.97332 11.0934 7.98665C10.4467 8.01998 9.8534 7.81332 9.40674 7.43332C10.0934 6.81998 10.4867 5.89999 10.4067 4.89999C10.3601 4.35999 10.1734 3.86665 9.89341 3.44665C10.1467 3.31999 10.4401 3.23999 10.7401 3.21332C12.0467 3.09999 13.2134 4.07332 13.3267 5.39332Z",
    fill: "#DCDBE7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.66 11.56C14.6067 12.2067 14.1933 12.7667 13.5 13.1467C12.8333 13.5133 11.9933 13.6867 11.16 13.6667C11.64 13.2333 11.92 12.6933 11.9733 12.12C12.04 11.2933 11.6467 10.5 10.86 9.86667C10.4133 9.51333 9.89333 9.23333 9.32666 9.02667C10.8 8.6 12.6533 8.88667 13.7933 9.80667C14.4067 10.3 14.72 10.92 14.66 11.56Z",
    fill: "#DCDBE7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileUser);
export default __webpack_public_path__ + "static/media/profile-user.e0921991a4e92330d36ea153b0def71e.svg";
export { ForwardRef as ReactComponent };